import React from "react";
import { Trophy, ArrowRightLeft, Terminal, GraduationCap, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const verticals = [{
  id: "forex-markets",
  ticker: "$FRX",
  title: "Forex Trading",
  description: "Access 70+ currency pairs with ultra-low spreads. Trade the world's most liquid market with 1:500 leverage.",
  icon: ArrowRightLeft,
  href: "/FundingPage"
}, {
  id: "stock-cfds",
  ticker: "$STK",
  title: "Stock CFDs",
  description: "Trade global equities from NYSE and NASDAQ. Zero commission on major tech stocks and blue-chip enterprises.",
  icon: Trophy,
  href: "/FundingPage"
}, {
  id: "commodities",
  ticker: "$CMD",
  title: "Commodities",
  description: "Speculate on Gold, Silver, and Brent Crude. Hedge against inflation with high-precision execution and deep liquidity.",
  icon: Terminal,
  href: "/AcademyPage"
}, {
  id: "digital-assets",
  ticker: "$CRP",
  title: "Digital Assets",
  description: "24/7 access to Bitcoin, Ethereum, and DeFi tokens. Institutional-grade security for your crypto-derivative portfolio.",
  icon: GraduationCap,
  href: "/AcademyPage"
}];
export default function CuratedResourceVerticals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="53789" id="global-asset-access" className="dark bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {verticals.map((item, i) => <Link key={item.id} to={item.href} className="group block h-full outline-none" data-index={i}>
              <Card className="h-full bg-card/50 backdrop-blur-sm border-border transition-all duration-400 hover:border-primary/50 hover:shadow-[0_0_40px_-15px_rgba(6,182,212,0.3)] group-hover:-translate-y-1 flex flex-col rounded-sm">
                <CardHeader className="pb-4">
                  <div className="flex justify-between items-start w-full">
                    <span className="font-mono text-primary text-xs tracking-widest bg-primary/10 px-2 py-1 rounded-none border-l-2 border-primary">
                      {item.ticker}
                    </span>
                    <item.icon className="w-8 h-8 text-muted-foreground group-hover:text-primary transition-colors duration-400" strokeWidth={1} />
                  </div>
                </CardHeader>
                
                <CardContent className="flex-grow space-y-4">
                  <h3 className="text-2xl font-sans font-bold tracking-tighter text-foreground group-hover:text-primary transition-colors duration-400 uppercase">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm font-medium leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>

                <CardFooter className="pt-4 border-t border-border/20 mt-auto">
                  <div className="flex items-center text-xs font-bold tracking-widest text-foreground group-hover:text-primary transition-colors duration-400 uppercase">
                    Trade Now
                    <ChevronRight className="w-4 h-4 ml-1 transition-transform duration-400 group-hover:translate-x-2" />
                  </div>
                </CardFooter>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}